import api from "../../../api";

export default {
  async getSections({ commit }) {
    commit("REQUEST_SECTIONS");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_SECTIONS",
        await api.getSections()
      );
    } catch (err) {
      commit("FAILURE_REQUEST_SECTIONS");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async deleteSection({ commit }, id) {
    commit("REQUEST_DELETE_SECTION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_DELETE_SECTION",
        await api.deleteSection(id)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_DELETE_SECTION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async updateSection({ commit }, item ) {
    commit("REQUEST_UPDATE_SECTION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_UPDATE_SECTION",
        await api.updateSection(item)
      );
    } catch (err) {
      commit("FAILURE_REQUEST_UPDATE_SECTION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  },
  async createSection({ commit }, item ) {
    commit("REQUEST_CREATE_SECTION");
    commit("SET_LOADING", true, { root: true });
    try {
      commit(
        "SUCCESS_REQUEST_CREATE_SECTION",
        await api.createSection( item )
      );
    } catch (err) {
      commit("FAILURE_REQUEST_CREATE_SECTION");
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }
};
